<template>
    <v-dialog v-model="visbility" dark persistent max-width="400">
        <v-card class="!bg-black pb-2 !border-0 !rounded-tr-2xl !rounded-bl-2xl">
            <v-card-title :class="`${routeLink}_fortext`" class="text-3xl  !break-normal text-center !block !font-Handel">
                Only for
                <span class="font-weight-bold"> Premium Members, </span> Subscribe Now
                for Premium Package
            </v-card-title>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="white--text font-Handel" small text @click.prevent="$store.dispatch('premiumModalFn' , false)">
                    Cancel
                </v-btn>

                <v-btn class="font-Handel " :class="`${routeLink}_color`" small @click.prevent="subscribePremiumFn">
                    Subscribe Now
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {

    data() {
        return {
            premiumDialog: true,
        }
    },
    computed: {
        visbility() {
            return this.$store.getters.isPremiumModalOpened
        }
    },
    methods: {
        subscribePremiumFn(){
            this.$store.dispatch('premiumModalFn' , false)
            this.$router.push({name : 'Plan' })
            console.log('Subscribing')
        }
    },
}
</script>
<style scoped>
.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(345deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%);
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(39deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%);
}
</style>